module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Medium-Alphabetic.8b087b50.woff2";